export function getStudyProgrammesForStreamOrFinality(streamHref, allPrograms) {
  return allPrograms.filter((e) =>
    e.studyProgrammeGroups.some((spg) => spg.studyProgrammeGroup.href === streamHref),
  );
}

export const hasAny = (list, listToCompare) => {
  return list.reduce((isInList, item) => {
    return listToCompare.includes(item) || isInList;
  }, false);
};
